<template lang="pug">
  v-container(fluid)
    v-row
        WeekSelector(:isoWeek.sync="selectorIsoWeek" :allowNavigationToPast="false" :date="date")
    v-row(v-if="!isKioskMode")
        v-container.pa-0(v-if="menuOfferCollection === null" fluid)
            v-skeleton-loader(type="list-item-three-line@7")
        OfferItem.pt-0.pb-0(
            v-if="menuOfferCollection && menuOfferCollection.length"
            v-for="(menuOfferItem, idx) in menuOfferCollection" :key="idx"
            :offerItem="menuOfferItem" :reservationItem="findReservationItem(menuOfferItem)" :date="date"
        )
    v-row.ma-0.text-start(v-else align="start" justify="start" )
      v-container.pa-0.fill-height(v-if="menuOfferCollection === null" fluid)
        v-skeleton-loader(type="list-item-three-line@7")
      v-list.fill-height.pl-0(width="100vh" )
        v-list-item-group(v-model="selectedDate" )
          v-list-item.pa-0(v-for="(menuOfferItem, idx) in menuOfferCollection" :key="idx")
            v-list-item-content()
              OfferItem.pt-0.pb-0(
                v-if="menuOfferCollection && menuOfferCollection.length"
                :menuOfferCollection="menuOfferCollection"
                :offerItem="menuOfferItem" :reservationItem="findReservationItem(menuOfferItem)" :date="date"
              )

</template>

<script lang="ts">
import Vue from 'vue'
import moment from 'moment'
import WeekSelector from '@/components/calendar/CalendarWeekSelector.vue'
import OfferItem from '@/components/order/CalendarOfferItem.vue'
import DailyMenuOffer from '@/model/DailyMenuOffer'
import MenuReservationItem from '@/model/MenuReservationItem'
import {Component, Prop, Watch} from "vue-property-decorator";
import {GET_MODE} from "@/store/getter-types";

@Component ({
  components: {
    WeekSelector,
    OfferItem
  }
})
export default class Calendar extends Vue {

  @Prop({type: String, required: true}) readonly isoWeek!: string
  @Prop({type: Date}) date!: Date
  @Prop({type: Array as () => DailyMenuOffer[] | null}) menuOfferCollection!: DailyMenuOffer[] | null
  @Prop({type: Array as () => MenuReservationItem[] | null}) reservationCollection!: MenuReservationItem[] | null

  private selectedDate: number | null = null

  @Watch('menuOfferCollection')
  watchMenuOfferCollection (newVal: DailyMenuOffer[]): void {
    if(newVal && this.menuOfferCollection) {
      const foundDate: DailyMenuOffer | undefined = this.menuOfferCollection.find((item: DailyMenuOffer) => moment(item.date).format('YYYY-MM-DD') === this.$route.params.date)
      if(foundDate && this.menuOfferCollection) {
        this.selectedDate = this.menuOfferCollection.indexOf(foundDate)
      }
    }
  }

  getRowColor (menuOfferItem: DailyMenuOffer): string {
    const reservationItem: any = this.findReservationItem(menuOfferItem)
    if(this.findReservationItem(menuOfferItem) && reservationItem.status === 'active') {
      return 'light-green lighten-3'
    } else if(this.findReservationItem(menuOfferItem) && reservationItem.status === 'canceled'){
      return 'red accent-1'
    } else {
      return ''
    }
  }

  get selectorIsoWeek(): string {
    return this.isoWeek
  }

  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  set selectorIsoWeek(newVal: string) {
    this.$emit('update:isoWeek', newVal)
  }

  findReservationItem (offerItem: DailyMenuOffer): MenuReservationItem[] | undefined {
    if (this.reservationCollection) {
      return this.reservationCollection.filter((item: MenuReservationItem) => moment(item.date).isSame(offerItem.date, 'date'))
    }
    return undefined
  }

  onChangeDate (date: string): void {
    this.$emit('update:date', new Date(date))
  }
}
</script>

<style lang="stylus" scoped>


</style>
